/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Happy_Wry_Crane_KnitInputs */

const en_happy_wry_crane_knit = /** @type {(inputs: Happy_Wry_Crane_KnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} segment(s)`)
};

const de_happy_wry_crane_knit = /** @type {(inputs: Happy_Wry_Crane_KnitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Segment(e)`)
};

/**
* | output |
* | --- |
* | "{count} segment(s)" |
*
* @param {Happy_Wry_Crane_KnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_wry_crane_knit = /** @type {((inputs: Happy_Wry_Crane_KnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Wry_Crane_KnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_wry_crane_knit(inputs)
	return de_happy_wry_crane_knit(inputs)
});